export default function CTASection() {
  return (
    <section className="w-full relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20inviting%20modern%20workspace%20scene%20viewed%20from%20above%20with%20laptop%20tablet%20and%20coffee%20cup%20arranged%20on%20a%20light%20oak%20desk%2C%20soft%20golden%20hour%20sunlight%20casting%20long%20gentle%20shadows%2C%20cream%20walls%2C%20indoor%20plants%20in%20ceramic%20pots%2C%20organized%20creative%20studio%20atmosphere%2C%20clean%20Scandinavian%20aesthetic%2C%20soft%20diffused%20light%2C%20neutral%20warm%20earthy%20tones%2C%20editorial%20interior%20photography%2C%20high%20detail%2C%20productive%20calm%20feeling&width=1800&height=700&seq=cta-bg-v2&orientation=landscape"
          alt="Vigorbuy Spreadsheet CTA background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-white mb-4">
          Ready To Explore The Latest Vigorbuy Spreadsheet?
        </h2>
        <p className="text-sm md:text-base text-white/70 max-w-lg mx-auto mb-8 leading-relaxed">
          Access the most comprehensive product research database. Browse categories, compare products, and find exactly what you are looking for.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-md bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-shopping-bag-3-line text-lg"></i>
            Buy It Now
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-md bg-white/20 backdrop-blur-sm border border-white/30 text-white font-semibold text-base hover:bg-white/30 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-external-link-line text-lg"></i>
            Visit Main Website
          </a>
        </div>
      </div>
    </section>
  );
}